<template>
  <h1>Contact Us</h1>
  <p>Any questions? Please fell free to contact us.</p>

  <p>We're here to help! Whether you have questions about our AI tools, need assistance with your subscription, or want to explore partnership opportunities, the SharkFoto team is ready to assist you.</p>

  <h3 id="get-in-touch">Get in Touch</h3>
  <p>We currently provide 24/7 Email Support to ensure your questions are answered as quickly as possible.</p>
  <p>Email: <a href="mailto:support@sharkfoto.com">support@sharkfoto.com</a></p>
  <p>When reaching out, please include relevant details such as your account email, order number (if applicable), and a clear description of your issue so we can assist you efficiently.</p>

  <h3 id="common-inquiries">Common Inquiries</h3>
  <p>Before sending an email, you might find the answer you need in our resources:</p>
  <ul>
    <li>Pricing &amp; Subscriptions: For questions about credits, plans, or payment methods, please visit our <a href="https://sharkfoto.com/pricing/">Pricing FAQs</a>.</li>
    <li>Refunds: To understand our refund eligibility and process, please review our <a href="/company/trust/refund-policy">Refund Policy</a>.</li>
    <li>Privacy &amp; Security: Learn how we protect your data in our <a href="/company/trust/privacy">Privacy Policy</a>.</li>
  </ul>

  <h3 id="business-and-partnerships">Business &amp; Partnerships</h3>
  <p>Interested in integrating SharkFoto's API, exploring enterprise solutions, or discussing marketing partnerships? We'd love to hear from you.</p>
  <p>Please email us at <a href="mailto:support@sharkfoto.com">support@sharkfoto.com</a> with the subject line starting with [Partnership] or [Enterprise], and our business team will get back to you promptly.We strive to respond to all inquiries within 24 hours. Thank you for choosing SharkFoto!</p>
</template>

<script setup>
definePageMeta({ layout: "company" });

useHead({
  title: "Contact Us | SharkFoto",
  meta: [
    {
      name: "description",
      content:
        "Contact the SharkFoto team for help with our AI tools, subscriptions, refunds, privacy, or business and partnership inquiries. 24/7 email support at support@sharkfoto.com.",
    },
  ],
  link: [
    { rel: "canonical", href: "https://sharkfoto.com/company/contact-us/" },
  ],
});
</script>
